import { NAME} from './constants';

export const selectedDetailActivity = state => state[NAME].selectedDetailActivity